import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { ReaderConnection } from '@racemap/utilities/types/trackers';
import { type FC, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useStore } from '../../../store/reducers';
import { CopyButton } from '../../BasicComponents/CopyButton';
import { HStack } from '../../BasicComponents/MetaComponent';
import { QRCode } from '../../BasicComponents/QRCode';
import { IconFail, IconMobileAlt, IconOk } from '../../Icon';

export const ConnectScannerButton: FC = () => {
  const [show, setShow] = useState(false);
  const sessionId = useStore((s) => s.trackers.sessionId);
  const connections = useStore((s) => s.trackers.connectedReader);
  const { startSession } = useStore((s) => s.trackers.actions);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <Container onClick={() => setShow(true)}>
        <IconMobileAlt fixedWidth />
      </Container>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Connect Scanner App with your Tracker Managment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <QRCodeAndConnections>
            <QRCodeAndSessionId>
              <InfoText>
                Scan that QR-Code with our Orga App, to add Tracker per NFC or QR-Code scan.
              </InfoText>

              {sessionId != null ? (
                <>
                  <QRCode
                    value={`https://racemap.com/orgaApp/scanSession?sessionId=${sessionId}`}
                    withLinkField={false}
                  />
                  <CopyButton label={`Session: ${sessionId}`} link={sessionId} />
                </>
              ) : (
                <Button onClick={() => startSession()}>Start new Session</Button>
              )}
            </QRCodeAndSessionId>

            <ConnectionsContainer>
              <Label>Connections:</Label>
              <ConnectionsList>
                {Array.from(connections).map(([readerId, connection]) => (
                  <Connection key={readerId} connection={connection} />
                ))}
              </ConnectionsList>
            </ConnectionsContainer>
          </QRCodeAndConnections>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const Connection: FC<{ connection: ReaderConnection }> = ({ connection }) => {
  return (
    <ConnectionContainer>
      <ConnectionIconAndName>
        <IconMobileAlt fixedWidth />
        <div>{connection.readerName || connection.readerId}</div>
      </ConnectionIconAndName>
      {connection.state === 'CONNECTED' && <IconOk color={RacemapColors.BaseGreen} />}
      {connection.state === 'DISCONNECTED' && <IconFail color={RacemapColors.DarkRed} />}
    </ConnectionContainer>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const QRCodeAndConnections = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px;
`;
const ConnectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 300px;
`;
const QRCodeAndSessionId = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Label = styled.div`
  font-weight: 600;
  font-size: large;
`;
const InfoText = styled.div`
  margin: 0 30px 20px;
  text-align: center;
  color: ${RacemapColors.DarkGray};
`;
const ConnectionsList = styled.div`
  width: 100%;
`;
const ConnectionContainer = styled(HStack)`
  margin: 5px;
  padding: 5px;
  border: solid 1px ${RacemapColors.DarkGray};
  width: 100%;
  border-radius: 5px;
`;
const ConnectionIconAndName = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 600;
  align-items: center;

  svg {
    padding-right: 5px;
  }
`;
